import { HttpClient } from './types';

export const createCategoryService = (httpClient: HttpClient) => {
  const getEndpoint = (url: string): string => `/categorias${url}`;

  return {
    getAllCategories: <TCategory = any>(): Promise<TCategory[]> => {
      return httpClient.get<TCategory[]>(getEndpoint(''));
    },

    getCategoryById: <TCategory = any>(categoryId: number): Promise<TCategory> => {
      return httpClient.get<TCategory>(getEndpoint(`/${categoryId}`));
    },
  };
};

